import React, { useEffect, useState } from "react";
import Modal from "../../elements/front/Modal";
import Avatar from "../../form/front/Avatar";
import { reactionList } from "../../../services/postService";

const ReactionLiksModal = ({ isOpen, onClose, postId }) => {
  const [likesData, setLikesData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch reaction data when the modal is opened and postId is available
  useEffect(() => {
    const fetchLikes = async () => {
      if (!postId) return;

      try {
        setLoading(true);
        const response = await reactionList({
          referenceId: postId,
        });
        setLikesData(response?.docs?.data || []);
      } catch (error) {
        console.error("Failed to fetch reactions", error);
      } finally {
        setLoading(false);
      }
    };

    if (isOpen) {
      fetchLikes();
    }
  }, [isOpen, postId]);

  if (loading) {
    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
        title={"People who liked this Post"}
      >
        <div className="p-4 text-center">Loading...</div>
      </Modal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
      title={"People who liked this Post"}
      titleClass={"text-base md:!text-lg"}
      bodyClasses="md:pr-2"
    >
      <div className="max-h-[70vh] overflow-y-auto">
        {likesData.length === 0 ? (
          <div className="text-center text-gray-500 py-4">
            No reactions yet.
          </div>
        ) : (
          likesData.map((likeItem, index) => {
            const { firstName, lastName, image, bio } =
              likeItem.userDetails || {};
            const userName = `${firstName || "User"} ${lastName || ""}`;
            const profileImage = image?.url || "";

            return (
              <div
                key={index}
                className="flex items-start gap-3 py-3 border-b border-gray-200"
              >
                <Avatar image={profileImage} name={userName} size={38} />

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1">
                    <h4 className="text-[14px] font-semibold text-gray-900 leading-[1.2] truncate">
                      {userName}
                    </h4>
                  </div>

                  <p className="text-[12.5px] text-gray-600 leading-[1.3] mt-[2px] line-clamp-2">
                    {bio || "No bio available"}
                  </p>
                </div>
              </div>
            );
          })
        )}
      </div>
    </Modal>
  );
};

export default ReactionLiksModal;
